import { FC, ReactNode } from "react"

type IProps = {
    children: ReactNode,
    to: string,
    className?: string
}

const LinkComponent: FC<IProps> = ({ children, className = '', to, ...otherProps }) => {
    return (
        <a href={to} className={`${className}`} {...otherProps}>{children}</a>
    )
}

export default LinkComponent